import { render, staticRenderFns } from "./WriteProspects.vue?vue&type=template&id=e81160b0&"
import script from "./WriteProspects.vue?vue&type=script&lang=js&"
export * from "./WriteProspects.vue?vue&type=script&lang=js&"
import style0 from "./WriteProspects.vue?vue&type=style&index=0&id=e81160b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports